/**
 * Created by swandelow on 18/09/18.
 */

import {FormControl} from "@angular/forms";
import {ValidatorService} from "../../core/validator.service";

export class RestrictionsFormValidator {

    static lengthComparator(c: FormControl){
        let result : any = {};
        if(c.value.maxRentalLength < c.value.minRentalLength){
            result.maxRentalLength = true;
        }
        return RestrictionsFormValidator.isEmpty(result) ? null : result;
    }

    static positiveValueWrapper(c: FormControl){
        return ValidatorService.positiveValue(c) ? null : {
            posName: {
                valid: false
            }
        };
    }

    static periodValidator(fc: FormControl) {
        let result : any = {};
        if (!!fc.value && fc.value.config != "date_always") {
            if (!fc.value.period.from) {
                result.requiredFrom = true;
            }
            if (!fc.value.period.to) {
                result.requiredTo = true;
            }
            if (!!fc.value.period.from && !!fc.value.period.to && fc.value.period.from > fc.value.period.to) {
                result.invalidRange = true;
            }
        }
        return RestrictionsFormValidator.isEmpty(result) ? null : result;
    }

    private static isEmpty(object: any): boolean {
        return !Object.keys(object).length;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/restrictions-form-validator.ts